module.exports = __webpack_public_path__ + "static/media/6.37436ce8.png";